// extracted by mini-css-extract-plugin
module.exports = {"textInputRoot":"styles_textInputRoot__pUVLH","labelText":"styles_labelText__T0wsJ","helperText":"styles_helperText__PAv6y"};